// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".compgrid{display:grid;grid-template-columns:1fr 1fr 1fr}.centervert{vertical-align:middle}", ""]);
// Exports
module.exports = exports;
